import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CustomTextField from "../custom/CustomTextField";
import { isBlank } from "../../utils/ValidationRules";
import CustomButton from "../custom/CustomButton";
import apiClient from "../../utils/apiClient";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";

const InsertPublikasiModal = ({ open, onClose, onSuccess }) => {
  const [namaPublikasi, setNamaPublikasi] = useState("");
  const [judulPublikasi, setJudulPublikasi] = useState("");

  useEffect(() => {
    if (!open) return;
    setNamaPublikasi("");
    setJudulPublikasi("");
  }, [open]);

  const submitPublikasi = (event) => {
    event.preventDefault();
    Swal.fire({
      text: "Masukkan publikasi baru ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, masukan",
      cancelButtonText: "Tidak, jangan masukkan",
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then((result) => {
      if (result.isConfirmed) {
        apiClient
          .post("/journal", {
            namaJurnal: namaPublikasi,
            judul: judulPublikasi,
          })
          .then((response) => {
            showSuccessToast(response.data.msg);
            onSuccess();
          })
          .catch((err) => {
            showErrorToast(err.response.data.msg);
          });
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Tambah Publikasi</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Typography>
              Nama Publikasi<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={namaPublikasi}
              rule={(value) => isBlank(value, "Nama Publikasi")}
              onChange={(event) => setNamaPublikasi(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Judul Publikasi<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={judulPublikasi}
              rule={(value) => isBlank(value, "Judul Publikasi")}
              onChange={(event) => setJudulPublikasi(event.target.value)}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <CustomButton
              text="Submit"
              baseColor="#003158"
              hoverColor="#00213A"
              onClick={submitPublikasi}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default InsertPublikasiModal;
